// NOTE: The following errors have been suppressed since this component will be deprecated
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @opendoor/no-html-elements */
/* eslint-disable jsdoc/require-jsdoc */
import styled from '@emotion/styled';
import React from 'react';

import {
  media,
  BREAKPOINTS_DICT,
} from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';
import { heightsWithUnits, spaceWithUnits, colors } from '@opendoor/bricks/theme/eero';
import { useOutsideClickAlerter } from '@opendoor/bricks/hooks/useOutsideClickAlerter';
import { hiddenLgUp, hiddenLgDown } from '@opendoor/bricks/system/hidden';
import { Icon, Box, ListItem, Loader } from '@opendoor/bricks/core';
import { NavExitLinkIcon } from '@opendoor/bricks/deprecated/UNSAFE_icons';
import FixedHeaderFooterPortalContainer from '@opendoor/bricks/deprecated/UNSAFE_layout/FixedHeaderFooterPortalContainer';
import {
  Layout,
  FooterType,
  HeaderType,
  FixedHeaderZIndex,
} from 'sellDirect/components/legacy/layout/Layout';
import { PrimaryNavSubmenu } from 'sellDirect/components/legacy/layout/Header';
import Footer from '@opendoor/bricks/deprecated/UNSAFE_layout/Footer';
import { SerializedStyles } from '@emotion/react';
import { ExternalLink } from 'platform/react-router';

const NAV_MENU_ID = 'dashboard-layout-nav-menu';
const NAV_MENU_BUTTON_ID = 'dashboard-layout-nav-menu-button';

export interface IDashboardLayoutWrapperAccountInfo {
  email: string;
  hasPartnershipReferralDashboard?: boolean;
  hasPartnershipReportingDashboard?: boolean;
  hasPartnershipDeveloperDashboard?: boolean;
  hasResaleClosingDashboard?: boolean;
  leads: Array<{
    readableState?: string;
    streetName: string;
    url: string;
  }>;
  name: string;
}

export interface IDashboardLayoutWrapperStyle {
  dashboardLayoutWrapper?: SerializedStyles;
  dashboardLayoutWrapperChildrenContainer?: SerializedStyles;
}
export interface IDashboardLayoutWrapperProps {
  // Prefix of the name of the dashboard layout wrapper, which should just be the app name
  analyticsName: string;
  accountInfo?: IDashboardLayoutWrapperAccountInfo;
  isLoadingAccountInfo?: boolean;
  footerType?: FooterType;
  headerType?: HeaderType;
  onLogout?: () => void; // shared session logout is done async
  opendoorDomain?: string;
  renderLogo?: () => JSX.Element | null;
  renderNav?: (onMobileClose: () => void) => React.ReactNode;
  onBackClick?: () => void;
  style?: IDashboardLayoutWrapperStyle;
}

export const FIXED_FOOTER_CONTAINER_ID = 'od-fixed-footer-container-id';
export const FIXED_HEADER_CONTAINER_ID = 'od-fixed-header-container-id';

// storybook-check-ignore
export const DashboardLayoutWrapper: React.FC<IDashboardLayoutWrapperProps> = ({
  analyticsName,
  headerType = 'HIDE_NAV',
  accountInfo,
  isLoadingAccountInfo,
  footerType,
  onLogout,
  opendoorDomain = '',
  renderLogo,
  renderNav,
  onBackClick,
  style = {},
  children,
}) => {
  const [mobileNavVisible, setMobileNavVisible] = React.useState(false);
  const overlayRef = React.useRef<HTMLDivElement>(null);

  const hideMobileNav = () => {
    setMobileNavVisible(false);
  };

  const showMobileNav = () => {
    setMobileNavVisible(true);
  };

  const onOverlayClick = (e: React.MouseEvent<HTMLElement>) => {
    if (overlayRef && overlayRef.current === e.target) {
      hideMobileNav();
    }
  };

  // dont render the side-nav if the backbutton is showing
  const renderedNav = !onBackClick && renderNav && renderNav(hideMobileNav);

  const renderAccountMenu = () => {
    return accountMenuRenderer({
      accountInfo,
      isLoadingAccountInfo,
      onLogout,
      opendoorDomain,
      analyticsName,
    });
  };

  return (
    <Layout
      analyticsName={analyticsName}
      fixedHeader={true}
      mobileNavVisible={mobileNavVisible}
      footerType={footerType ? footerType : 'NONE'}
      headerType={headerType}
      renderAccountMenu={renderAccountMenu}
      renderLogo={renderLogo}
      onBackClick={onBackClick}
      hideMobileNav={hideMobileNav}
      showMobileNav={showMobileNav}
      hasRenderedNav={!!renderedNav}
    >
      <StyledDashboardLayoutWrapper overrideStyles={style?.dashboardLayoutWrapper}>
        <DashboardLayoutWrapperContent>
          <FixedHeaderFooterPortalContainer
            fixedFooterContainerId={FIXED_FOOTER_CONTAINER_ID}
            fixedHeaderContainerId={FIXED_HEADER_CONTAINER_ID}
          >
            <DashboardLayoutWrapperMobileMenuContainer
              aria-labelledby={NAV_MENU_BUTTON_ID}
              id={NAV_MENU_ID}
              onClick={onOverlayClick}
              ref={overlayRef}
              role="menu"
              style={{
                zIndex: mobileNavVisible ? FixedHeaderZIndex - 1 : 'auto',
                top: 0,
              }}
            >
              <DashboardLayoutWrapperMobileMenu
                style={{ transform: mobileNavVisible ? 'translateX(0)' : 'translateX(-100%)' }}
              >
                <DashboardLayoutWrapperMobileSubMenu>
                  {renderedNav}
                </DashboardLayoutWrapperMobileSubMenu>
              </DashboardLayoutWrapperMobileMenu>
            </DashboardLayoutWrapperMobileMenuContainer>

            {/* desktop */}
            {renderedNav && (
              <DashboardLayoutWrapperNavContainer>
                <DashboardLayoutWrapperNav>{renderedNav}</DashboardLayoutWrapperNav>
              </DashboardLayoutWrapperNavContainer>
            )}
            <DashboardLayoutWrapperChildrenContainer
              overrideStyles={style?.dashboardLayoutWrapperChildrenContainer}
            >
              <DashboardLayoutWrapperChildren>{children}</DashboardLayoutWrapperChildren>
              {footerType ? null : (
                <Footer analyticsName={`${analyticsName}-footer`} centerAlign={false} />
              )}
            </DashboardLayoutWrapperChildrenContainer>
          </FixedHeaderFooterPortalContainer>
        </DashboardLayoutWrapperContent>
      </StyledDashboardLayoutWrapper>
    </Layout>
  );
};
interface IAccountMenuRenderer {
  accountInfo: IDashboardLayoutWrapperProps['accountInfo'];
  isLoadingAccountInfo: IDashboardLayoutWrapperProps['isLoadingAccountInfo'];
  onLogout: IDashboardLayoutWrapperProps['onLogout'];
  opendoorDomain: IDashboardLayoutWrapperProps['opendoorDomain'];
  analyticsName: IDashboardLayoutWrapperProps['analyticsName'];
}

export const accountMenuRenderer = ({
  accountInfo,
  isLoadingAccountInfo,
  onLogout,
  opendoorDomain,
  analyticsName,
}: IAccountMenuRenderer) => {
  const loginURL = `${opendoorDomain}/login?redirectTo=${location.href}`;
  const [accountMenuVisible, setAccountMenuVisible] = React.useState(false);

  // Logic for handling click outside of account menu
  const ref = React.useRef<HTMLDivElement>(null);
  const onClickOutside = React.useCallback(
    () => setAccountMenuVisible(false),
    [setAccountMenuVisible],
  );
  useOutsideClickAlerter(ref, onClickOutside);

  const isAuthenticated = accountInfo && (accountInfo.email || accountInfo.name);
  const firstName = accountInfo ? accountInfo.name.split(' ')[0] : '';

  const authDropdown = (
    <React.Fragment>
      <AccountMenuItem display="flex">
        <AccountLink
          href={`${opendoorDomain}/account`}
          target="_blank"
          analyticsName={`${analyticsName}-account`}
          aria-label="Opens new window with account information"
        >
          Account <NavExitLinkIcon display="flex" marginLeft={spaceWithUnits[2]} />
        </AccountLink>
      </AccountMenuItem>
      <AccountMenuItem display="flex">
        <AccountLink onClick={onLogout} analyticsName={`${analyticsName}-sign-out`} aria-label="">
          Sign out
        </AccountLink>
      </AccountMenuItem>
    </React.Fragment>
  );

  if (isLoadingAccountInfo) {
    return <Loader />;
  }

  return (
    <div ref={ref}>
      <Box position="relative">
        {isAuthenticated ? (
          <Box cursor="pointer">
            <Box onClick={() => setAccountMenuVisible(!accountMenuVisible)} fontWeight="semibold">
              Welcome {firstName} &nbsp;
              <Box display="inline-block" width="1em" height="1em" mb="0.2em">
                <Icon name="chevron-down" />
              </Box>
            </Box>
          </Box>
        ) : (
          <ExternalLink
            href={loginURL}
            fontWeight="semibold"
            analyticsName={`${analyticsName}-sign-in`}
            aria-label=""
          >
            Sign In
          </ExternalLink>
        )}
        {accountMenuVisible && <Account>{isAuthenticated && authDropdown}</Account>}
      </Box>
    </div>
  );
};

const AccountLink = styled(ExternalLink)`
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const dashboardNavWidth = BREAKPOINTS_DICT.LG / 4;
const childrenDesktopWidth = (BREAKPOINTS_DICT.LG * 3) / 4;

const StyledDashboardLayoutWrapper = styled(Box)<{ overrideStyles?: SerializedStyles }>`
  background-color: ${colors.neutrals0};
  min-height: calc(100vh - ${heightsWithUnits.header});

  ${media.smallerThan.SM} {
    min-height: calc(100vh - 52px);
  }

  ${(props) => props.overrideStyles}
`;

const DashboardLayoutWrapperContent = styled.div`
  ${media.largerThan.LG} {
    margin: 0 auto;
    width: ${BREAKPOINTS_DICT.LG}px;
  }
`;

const DashboardLayoutWrapperNavContainer = styled.div`
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  padding: ${spaceWithUnits[7]};
  position: fixed;
  top: ${heightsWithUnits.header};
  width: ${dashboardNavWidth}px;

  ${media.smallerThan.XS} {
    top: 52px;
  }

  ${hiddenLgDown}
`;

const DashboardLayoutWrapperChildrenContainer = styled(Box)<{ overrideStyles?: SerializedStyles }>`
  ${media.largerThan.MD} {
    padding: ${spaceWithUnits[7]};
  }

  ${media.largerThan.LG} {
    padding-left: ${dashboardNavWidth}px;
  }

  ${(props) => props.overrideStyles}
`;

const DashboardLayoutWrapperNav = styled.div`
  flex-basis: 100%;
  height: 100%;
  overflow: auto;
`;

const DashboardLayoutWrapperChildren = styled.div`
  ${media.largerThan.LG} {
    max-width: ${childrenDesktopWidth}px;
  }
`;

const DashboardLayoutWrapperMobileMenuContainer = styled.nav`
  background-color: ${colors.neutrals0};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: ${heightsWithUnits.header};
  z-index: -100;

  ${media.smallerThan.XS} {
    top: 52px;
  }

  ${hiddenLgUp}
`;

const DashboardLayoutWrapperMobileMenu = styled.div`
  background-color: ${colors.neutrals0};
  height: 100%;
  overflow: auto;
  padding: ${spaceWithUnits[7]} 0;
  transform: translateX(-100%);
  transition: transform 200ms;
  width: ${dashboardNavWidth}px;
  position: fixed;
  padding-top: ${heightsWithUnits.header};
  left: 0;
`;

const DashboardLayoutWrapperMobileSubMenu = styled.div`
  padding: 0 ${spaceWithUnits[8]};
`;

const Account = styled(PrimaryNavSubmenu)`
  left: auto;
  right: 0;
  text-align: right;
  padding: ${spaceWithUnits[5]};

  top: 54px;
  visibility: visible;
  opacity: 1;

  &:before {
    right: 10px;
    left: inherit;
  }
`;

const AccountMenuItem = styled(ListItem)`
  margin-top: ${spaceWithUnits[4]};

  &:first-of-type {
    margin: initial;
  }
`;

DashboardLayoutWrapper.displayName = 'DashboardLayoutWrapper';
